import { render, staticRenderFns } from "./WxAlertQueryMessage.vue?vue&type=template&id=7f9faf70&scoped=true"
import script from "./WxAlertQueryMessage.vue?vue&type=script&lang=js"
export * from "./WxAlertQueryMessage.vue?vue&type=script&lang=js"
import style0 from "./WxAlertQueryMessage.vue?vue&type=style&index=0&id=7f9faf70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9faf70",
  null
  
)

export default component.exports